module.exports = __webpack_public_path__ + "img/info3_p.9cf4fca1.svg";